import * as React from "react";

import { IText } from "../../classes/text";

export interface IRecurrencePatternSaveAndCancelButtons {
	text: IText;
	allValidationIsPassed: boolean;
	saveHasBeenClicked: boolean;
	onSave: () => void;
	onCloseModal: () => void;
}

export const RecurrencePatternSaveAndCancelButtons: React.SFC<IRecurrencePatternSaveAndCancelButtons> = (props) => {

	const txt = props.text.eventViews;

	const onClickSaveButton = (event: any) => {
		props.onSave();

		if (props.allValidationIsPassed) {
			closeModal(event);
		}
	};

	const onClickCancelButton = (event: any) => {
		closeModal(event);
	};

	const closeModal = (event: any): void => {
		event.preventDefault();
		props.onCloseModal();
	};

	let saveBtnClass = "CMS_button CMS_bAction";
	if (props.saveHasBeenClicked && !props.allValidationIsPassed) { saveBtnClass += " CMS_bDisabled"; }

	return (
		<div className="CMS_buttonGroup CMS_bg-R" style={{ verticalAlign: "bottom" }}>
			<a className={saveBtnClass} href="#" onClick={onClickSaveButton}>{txt.save}</a>
			<a className="CMS_button CMS_bCancel" href="#" onClick={onClickCancelButton} style={{ marginLeft: "5px" }}>{txt.cancel}</a>
		</div>
	);

};
